import { useEffect, useState } from "react";
import { Gem } from "lucide-react";
import { fetchHiddenGems } from "../../lib/api";
import { SectionHeader } from "./SectionHeader";
import { PickCard } from "./PickCard";

export const HiddenGems = () => {
  const [gems, setGems] = useState(null);

  useEffect(() => {
    fetchHiddenGems(4).then(setGems).catch(() => setGems([]));
  }, []);

  if (gems && gems.length === 0) return null;

  return (
    <section data-testid="home-hidden-gems" className="mt-12 sm:mt-16">
      <SectionHeader
        icon={Gem}
        eyebrow="Hidden gems"
        title="Genuinely good value, quietly brilliant"
      />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {(gems || Array.from({ length: 4 })).map((p, i) =>
          p ? <PickCard key={p.slug || i} pick={p} /> : (
            <div
              key={i}
              className="h-60 rounded-2xl bg-card border border-border animate-pulse"
            />
          ),
        )}
      </div>
    </section>
  );
};

export default HiddenGems;
